export { IconTooltip, type IconTooltipProps } from './icon-tooltip';
